import axios from 'axios'
import { endpoint } from '../config'

export function FETCH_WAZZUP(friendsOnly = false) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            const friendsOnlyFilter = friendsOnly ? `?friends_only=1` : ``
            axios({
                url: `${endpoint}/api/wazzup${friendsOnlyFilter}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'REPLACE_ALL_THREADS',
                    payload: res.data.data
                })
                resolve()
            })
        })
        
    }
}

export function FETCH_FILTERED_WAZZUP(id) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/users/${id}/wazzup`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'REPLACE_ALL_FILTERED_THREADS',
                    payload: res.data.data
                })
                resolve()
            })
        })
        
    }
}

export function LOAD_MORE_WAZZUP(page=1, friendsOnly = false) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            const friendsOnlyFilter = friendsOnly ? `&friends_only=1` : ``
            axios({
                url: `${endpoint}/api/wazzup?page=${page}${friendsOnlyFilter}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'APPEND_THREADS',
                    payload: res.data.data
                })
                resolve(res.data.data)
            }).catch(err => {
                reject(err)
            })
        })
        
    }
}

export function LOAD_MORE_FILTERED_WAZZUP(id, page=1) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/users/${id}/wazzup?page=${page}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'APPEND_FILTERED_THREADS',
                    payload: res.data.data
                })
                resolve()
            }).catch(err => {
                reject(err)
            })
        })
        
    }
}

export function ADD_THREAD(text, image, guildId = null, friendsOnly = false) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            const formData = new FormData()
            formData.append('text', text)
            if(image) {
                formData.append('imageFile', image.files[0]);
            }
            if(guildId) {
                formData.append('guild', guildId)
            }
            if(friendsOnly) {
                formData.append('friends_only', 1)
            }
            axios({
                url: `${endpoint}/api/wazzup`,
                method: 'POST',
                data: formData,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                }, 
            }).then(res => {
                if(!guildId) {
                    dispatch({
                        type: 'SET_THREADS',
                        payload: {
                            threads: [res.data.thread]
                        }
                    })
                }
                resolve()
            })
        })
    }
}

export function GET_CHATS_FOR_THREAD(threadId) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/wazzup/${threadId}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                resolve(res.data.data.messages)
            }).catch(reject)
        })
        
    }
}

export function ADD_CHAT_TO_THREAD(message, threadId) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            const { text, image } = message
            const formData = new FormData()

            formData.append('text', text)
            if(image) {
                formData.append('imageFile', image)
            }
            axios({
                url: `${endpoint}/api/wazzup/${threadId}`,
                method: 'POST',
                data: formData,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'content-type': 'multipart/form-data',
                }, 
            }).then(res => {
                resolve(res.data.message)
            }).catch(reject)
        })
        
    }
}

export function REMOVE_MESSAGE(id) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/messages/${id}/remove`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                resolve(res.data)
            }).catch(err => {
                console.log(err)
            })
        })
    }
}

export function LIKE(id) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            let likes = state().user.user.likes;
            axios({
                url: `${endpoint}/api/wazzup/${id}/like`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                likes.push(res.data.data._id);
                dispatch({
                    type: 'SET_USER',
                    payload: {...state().user.user, likes: likes}
                })
                resolve(res.data)
            }).catch(err => {
                console.log(err)
            })
        })
    }
}

export function UNLIKE(id) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            let likes = state().user.user.likes;
            axios({
                url: `${endpoint}/api/wazzup/${id}/dislike`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                likes = likes.filter(item => item !== res.data.data._id);
                dispatch({
                    type: 'SET_USER',
                    payload: {...state().user.user, likes: likes}
                })
                resolve(res.data)
            }).catch(err => {
                console.log(err)
            })
        })
    }
}

export function GET_LIKES(threadId) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/wazzup/${threadId}/likes`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                resolve(res.data.likes)
            }).catch(reject)
        })
        
    }
}


export function SET_CHAT_POPUP(id, old_scroll) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                dispatch({
                    type: 'SET_CHAT_POPUP',
                    payload: {id: id, old_scroll: old_scroll}
                })
                resolve()
            }, 100)
        })
    }
}

export function SET_WAZZUP_TYPE(text) {
    return {
        type: 'SET_WAZZUP_TYPE',
        payload: text
    }
}